// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"fill":"currentColor","d":"M23.0002 12C23.0002 18.0751 18.0754 23 12.0002 23C5.92511 23 1.00024 18.0751 1.00024 12C1.00024 5.92487 5.92511 1 12.0002 1C18.0754 1 23.0002 5.92487 23.0002 12ZM16.0002 12L12.0002 5.75L8.00024 12L11.0002 12V18H13.0002V12H16.0002Z"},"nodeName":"path","children":[]}]};

@tag('t-icon-arrow-up-circle-filled')
export default class ArrowUpCircleFilledIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'arrow-up-circle-filled',
    }
  }
}
